import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { map } from 'rxjs/operators';
import { LocalStorageService } from './local-storage.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { LocalStorageEnum } from '../models/enums/local-storage.enum';
import { NavigationStart, Router } from '@angular/router';
import { Login } from '../models/login';
import { BaseDatatable } from '../models/datatables/base.datatable';
import { Minority } from '../models/minority';
import { EducationLevel } from '../models/education-level';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  authChange$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this.isAuth);
  authStatus: boolean = this.isAuth;
  constructor(
    private router: Router,
    private requestService: RequestService,
    private localStorageService: LocalStorageService
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (this.authStatus != this.isAuth) {
          this.markStatusChange();
        }
      }
    });
  }

  login(data: { username: string; password: string }): Observable<Login> {
    return this.requestService.postJSON<Login>('/student/account/login', { data }).pipe(
      map(res => {
        this.localStorageService.set(LocalStorageEnum.token, res.token);
        this.localStorageService.set(LocalStorageEnum.refresh_token, res.refresh_token);
        this.localStorageService.set(LocalStorageEnum.user_id, res.user._id!);
        this.markStatusChange();
        return res;
      })
    );
  }

  getGeneralEducationLevel(data: {
    page?: number;
    limit?: number;
    search?: string;
  }): Observable<BaseDatatable<EducationLevel>> {
    return this.requestService.getJSON<BaseDatatable<EducationLevel>>('/student/account/general_education_level', {
      data,
      is_loading: true
    });
  }

  getMinority(data: { page?: number; limit?: number; search?: string }): Observable<BaseDatatable<Minority>> {
    return this.requestService.getJSON<BaseDatatable<Minority>>('/student/account/minority', {
      data,
      is_loading: true
    });
  }

  redirectToHome(data: { token: string; refresh_token: string; _id: string }): void {
    this.localStorageService.set(LocalStorageEnum.token, data.token);
    this.localStorageService.set(LocalStorageEnum.refresh_token, data.refresh_token);
    this.localStorageService.set(LocalStorageEnum.user_id, data._id!);
    this.markStatusChange();
  }

  register(data: any) {
    return this.requestService.postFile<any>('/student/account', { data })
  }

  logout(): Observable<string> {
    this.localStorageService.delete(LocalStorageEnum.token);
    this.localStorageService.delete(LocalStorageEnum.refresh_token);
    this.localStorageService.delete(LocalStorageEnum.user_id);
    this.localStorageService.delete(LocalStorageEnum.permissions);
    return new Observable<string>(observer => {
      observer.complete(); // complete function will be called when the observable is complete
      this.markStatusChange();
    });
  }

  private markStatusChange() {
    this.authChange$.next(this.isAuth);
    this.authStatus = this.isAuth;
  }

  get isAuth(): boolean {
    return this.localStorageService.get(LocalStorageEnum.token) ? true : false;
  }
}
